import "./TopNavBarComp.css";
import { defineComponent as c, ref as i, onMounted as p, openBlock as _, createElementBlock as u, renderSlot as m } from "vue";
import { _ as d } from "./_plugin-vue_export-helper.dad06003.js";
const v = /* @__PURE__ */ c({
  __name: "TopNavBarComp",
  setup(f) {
    const o = i(null), l = (a, e = null) => {
      var r;
      if (!e)
        return;
      const t = a.currentTarget, s = ((r = t == null ? void 0 : t.attributes.getNamedItem("disabled")) == null ? void 0 : r.value) === "true";
      if (!(!t || s)) {
        for (let n = 0; n < e.length; n++)
          e[n].classList.remove("selected");
        t.classList.add("selected");
      }
    };
    return p(() => {
      if (!o.value || !o.value)
        return;
      const e = o.value.getElementsByClassName("button");
      if (e)
        for (let t = 0; t < e.length; t++)
          e[t].addEventListener("click", (r) => {
            l(r, e);
          });
    }), (a, e) => (_(), u("div", {
      ref_key: "topNavBar",
      ref: o,
      class: "topNavBar"
    }, [
      m(a.$slots, "default")
    ], 512));
  }
});
const k = /* @__PURE__ */ d(v, [["__scopeId", "data-v-9410ccea"]]);
export {
  k as TopNavBarComp
};
//# sourceMappingURL=TopNavBarComp.js.map
